import { Component, computed, effect, inject, signal } from '@angular/core';

import { GroupService } from '../../../services/group.service';
import { Institution } from '../../../services/institution.service';
import { StateService } from '../../../services/state.service';

@Component({
  selector: 'app-print-group',
  standalone: true,
  imports: [],
  templateUrl: './print-group.component.html',
  styleUrl: './print-group.component.scss'
})
export class PrintGroupComponent {
  readonly institutions = signal<Institution[]>([]);

  readonly institution = inject(StateService).institution;
  readonly peer = inject(StateService).peer;
  readonly filteredGroup = inject(StateService).filteredGroup;
  private groupService = inject(GroupService);

  constructor() {
    effect(() => {
      const peer = this.peer();
      if (peer?.group) {
        this.groupService.getGroupInstitutions(this.institution()?.iid, peer.group.groupId).subscribe(institutions => {
          const filteredGroup = this.filteredGroup();
          if (filteredGroup && peer.group?.groupType != 30) {
            institutions = institutions.filter(i => filteredGroup.find(f => f.iid == i.iid)?.isSelected == true);
          }
          this.institutions.set(institutions);
        });
      }
    });
  }
}
